/* import __COLOCATED_TEMPLATE__ from './dac-options-container.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();